module.exports = __webpack_public_path__ + "static/media/tom_cole_&_henry_bristow_showreel.aaf93d25.mp4";